import styled, { css } from 'styled-components';

export const DropdownListItem = styled.li<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        font-size: 1rem;
        margin: 0;
        padding: 0.5rem;

        &:not(:last-of-type) {
            border-bottom: ${theme.commonStyles.brandPixel} solid
                ${theme.colors.secondary.tints[1].hex};
        }

        &:hover {
            background: ${theme.colors.secondary.tints[1].hex};
            cursor: pointer;
        }

        ${$isActive &&
        css`
            background-color: ${theme.colors.primary.hex};
            color: ${theme.colors.primaryContrast.hex};
        `}
    `}
`;

export const CheckboxListItem = styled.li`
    ${({ theme }) => css`
        padding: 0.75rem;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            padding: 1.25rem 0.5rem;
            border-top: ${theme.commonStyles.brandPixel} solid
                ${theme.colors.secondary.tints[1].hex};

            &:last-of-type {
                border-bottom: ${theme.commonStyles.brandPixel} solid
                    ${theme.colors.secondary.tints[1].hex};
            }
        }
    `}
`;
